exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-group.required .control-label:after {\n  content:\"*\";\n  color:red;\n  margin-left: 3px;\n}\n\n/*table {*/\n\n/*table-layout: fixed;*/\n\n/*}*/\n\n/*table th, table td {*/\n\n/*overflow: hidden;*/\n\n/*text-overflow: ellipsis;*/\n\n/*white-space: nowrap;*/\n\n/*}*/\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/developer/Downloads/SleepRestoreBackend/sleep-restore-boot/src/main/ngapp/src/app/tracks/tracks.component.css
// module id = ../../../../../src/app/tracks/tracks.component.css
// module chunks = main